import { computed, ref } from 'vue';
import { useGlobalSearchStore } from '../../stores';

export const useSearchQuery = () => {
  const globalSearchStore = useGlobalSearchStore();

  const query = ref<string>('');

  const isClearable = computed(() => query.value != '');

  const setQuery = (value: string) => {
    query.value = value;
    globalSearchStore.setQuery(value);
  };

  const clearQuery = () => {
    query.value = '';
  };

  return {
    query,
    isClearable,
    setQuery,
    clearQuery,
  };
};
